<script setup>
import { computed, ref } from "vue";

import MyExperiencesSummaryCard from "./MyExperiencesSummaryCard.vue";
import MyExperiencesSummaryCardSkeleton from "./MyExperiencesSummaryCardSkeleton.vue";

/**
  PanelDefinition {
    index: number,
    title: string,
    enabled: boolean,
    filterFn: (applicationList: [], cutoffDate: Date) => []
  }
*/

const props = defineProps({
  panelDefinition: {
    type: Object,
    default: undefined,
  },
  experienceList: {
    type: Array,
    default: [],
  },
  cutoffDate: {
    type: Date,
    default: new Date(),
  },
});

const emit = defineEmits(["start-loading"]);

const filteredApplications = computed(() => props.experienceList);

const loadedIds = ref([]);

const isLoaded = (applicationId) => loadedIds.value.includes(applicationId);

const handleImageLoaded = (applicationId) => {
  if (!loadedIds.value.includes(applicationId)) {
    loadedIds.value.push(applicationId);
  }
};
</script>
<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <div
      v-for="experience in filteredApplications"
      :key="experience.application_id"
      class="flex w-full"
    >
      <MyExperiencesSummaryCardSkeleton v-show="!isLoaded(experience.application_id)" />
      <MyExperiencesSummaryCard
        v-show="isLoaded(experience.application_id)"
        :experience="experience"
        :panel-definition="panelDefinition"
        @start-loading="emit('start-loading')"
        @image-loaded="handleImageLoaded(experience.application_id)"
      />
    </div>
  </div>
</template>
